import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'react-avatar';
import ImageSize from '../../../ImageSize/ImageSize';

import '../../../Checkbox/Checkbox.scss';

export class MemberItemRenderer extends Component {
  render() {
    const { label, option } = this.props;
    const img = {
      position: 'relative',
      overflow: 'hidden',
      display: 'inline-block',
      marginRight: '8px',
      marginLeft: '0px',
      width: '28px',
      height: '28px',
      borderRadius: '4px',
      border: '1px solid #ececec',
    };
    const noMarginLeft = {
      marginLeft: '0',
    };
    return (
      <div>
        {option.image ? (
          <div style={img}>
            <ImageSize src={option.image} alt="" />
          </div>
        ) : (
          <Avatar name={option.value === 'no-member' ? '✷' : label} size={26} style={img} round="4px" maxInitials={2} />
        )}
        <span style={noMarginLeft}>
          <span style={noMarginLeft}>{label}</span>
        </span>
      </div>
    );
  }
}

MemberItemRenderer.propTypes = {
  label: PropTypes.string.isRequired,
  option: PropTypes.object,
};
